import 'chosen-js/chosen.css';
import '../styles/advancedDropdown.less';
import 'chosen-js';
import 'jquery-truncate';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';
import { assign, retrieve } from '../../../loader/util';

var state;

/* eslint camelcase: off, no-unused-vars: off, max-depth: [error, 4], complexity: [error, 8] */

function htmlEscape(str) {
    var s = String(str)
            // Removed duplicate replaces to prevent double conversion (because in Chosen it is already converted)
            .replace(/\u00a0/g, ' ') // converting non-breaking space to space
            .replace(/\u0009/g, ' '); // converting tab to space
    return s;
}

/**
 * @param {Object} The jQuery object of the span which is the base of measurement.
 * @param {string} The name(s) of css class(es) which should be applied on the span. More items
 *                 are space separated. If no item is set, please set as null.
 * @param {string} The content which should be measured.
 * @param {boolean} The type of content is text (true) or html (false).
 * @return {number} Width of the span filled with the content and styled with the cssClassNames.
 */
function getContentWidth($span, cssClassNames, content, isText) {
    var width = 0;
    if (content && 0 < content.length) {
        if (cssClassNames) {
            $span.addClass(cssClassNames);
        }
        if (common.isString(content)) {
            if (isText) {
                $span.text(content);
            } else {
                $span.html(content);
            }
            width = $span.outerWidth();
        }
        if (cssClassNames) {
            $span.removeClass(cssClassNames);
        }
    }
    return width;
}

function getOptionLabel(option, labelType) {
    return labelType === 'html' ? option.text : option.html;
}

function getListWidth($span, chznObj, attrs) {
    var elemList = chznObj.results_data,
        elem,
        i = 0,
        len = elemList.length,
        maxWidth = 0,
        groupsWidth = 0,
        itemsWidth = 0,
        groupItemsWidth = 0,
        groups = '',
        items = '',
        groupItems = '';
    for (; i < len; i++) {
        elem = elemList[i];
        if (elem.label) { // group label: only valid group has children
            if (elem.children > 0) {
                groups += elem.label + '<br>';
            }
        } else if (elem.group_array_index) { // group item: only grouped item has index
            groupItems += getOptionLabel(elem, attrs.labelType) + '<br>';
        } else if (!elem.empty) { // normal item: non-grouped and non-empty item
            items += getOptionLabel(elem, attrs.labelType) + '<br>';
        }
    }
    itemsWidth = getContentWidth($span, null, items, false);
    groupItemsWidth = getContentWidth($span, 'uwr-advanced-dropdown-measure-groupitems', groupItems, false);
    groupsWidth = getContentWidth($span, 'uwr-advanced-dropdown-measure-groups', groups, false);
    maxWidth = Math.max(groupsWidth, itemsWidth, groupItemsWidth);
    return maxWidth;
}

function getAddWidths(chznObj, attrs) {
    var $span = $('<span class="uwr-advanced-dropdown-measure-items"></span>'),
        inputWidth = 0,
        maxWidth = 0;
    $('body').append($span);
    maxWidth = getListWidth($span, chznObj, attrs);
    if (isPlaceholderTextVisible(chznObj)) {
        inputWidth = getContentWidth($span, 'uwr-advanced-dropdown-measure-placeholder',
                chznObj.default_text, true);
        maxWidth = Math.max(inputWidth, maxWidth);
    } else {
        inputWidth = maxWidth;
    }
    $span.remove();

    return {
        maxOptionWidth: maxWidth,
        inputWidth: inputWidth
    };
}

/**
 * @param {Object} The chosen object associated to the current select (dropdown).
 * @return {boolean} Is placeholder text of this chosen object visible.
 */
function isPlaceholderTextVisible(chznObj) {
    var isMultipleSelect = chznObj.is_multiple,
        hasEmptyItem = false,
        isEmptyList = true,
        elemList = chznObj.results_data,
        elem;
    if (!isMultipleSelect) { // on multiple select the placeholder is always visible
        for (var i = 0; i < elemList.length; i++) {
            /* The empty {boolean} and html {string} attributes are chosen's inner representation of an option
                * - empty - if there is an option without value
                * - html - if groups are placed in only (group elements has only label)
                */
            elem = elemList[i];
            if (elem.empty) {
                hasEmptyItem = true;
                break;
            }
            if (isEmptyList && elem.html) {
                isEmptyList = false;
            }
        }
    }
    return isMultipleSelect || hasEmptyItem || isEmptyList;
}

function setLeftAlignHandler(chznObj, left) {
    chznObj.results_show = (function (resultShow, left) {
        return function (evt) {
            var result = resultShow.call(this, evt);
            this.dropdown.css({
                'left': left
            });
            return result;
        };
    })(chznObj.results_show, left);
}

function hasAttributeInStyle(stylesText, attrName) {
    var result = false,
        styles,
        style,
        i;
    if (stylesText && attrName) {
        styles = stylesText.split(';');
        for (i = 0; !result && i < styles.length; i++) {
            style = styles[i].split(':');
            if ($.trim(style[0]) === attrName) {
                result = true;
            }
        }
    }
    return result;
}

function isWidthSpecified(attrs) {
    if (attrs) {
        if (attrs.width || hasAttributeInStyle(attrs.style, 'width')) {
            return true;
        }
    }
    return false;
}

function setContainerWidth(chznObj, listWidth) {
    var $container = chznObj.container,
        containerNewWidth = listWidth + 2;
    $container.width(containerNewWidth);
}

function setListWidth(chznObj, attrs) {
    var isContainerWidthNotSpecified = !isWidthSpecified(attrs),
        listWidth,
        diff,
        addWidths;
    if (attrs.listAutoWidth === 'true' || isContainerWidthNotSpecified) {
        addWidths = getAddWidths(chznObj, attrs);
        listWidth = addWidths.maxOptionWidth;
        chznObj.f_width = addWidths.inputWidth;

        if (attrs.listMinWidth) {
            listWidth = Math.max(listWidth, attrs.listMinWidth);
        }
        if (attrs.listMaxWidth) {
            listWidth = Math.min(listWidth, attrs.listMaxWidth);
        }
        chznObj.dropdown.width(listWidth);

        if (isContainerWidthNotSpecified) {
            setContainerWidth(chznObj, listWidth);
        }

        if (attrs.listAlignment === 'left') {
            if (listWidth > chznObj.container.outerWidth()) {
                diff = listWidth - chznObj.container.outerWidth() + 2;
                setLeftAlignHandler(chznObj, -diff);
            }
        }

        chznObj.search_field_scale();
    }
}

function setListHeight(chznObj, attrs) {
    if ($.isNumeric(attrs.listMaxHeight)) {
        chznObj.search_results.css('max-height', parseInt(attrs.listMaxHeight, 10));
    }
}

function changeSelectedText(chznObj, visibleTrailChars) {
    var $choices,
        $toTruncate,
        $parent,
        wdiff,
        width,
        $item;
    if (visibleTrailChars) {
        if (chznObj.is_multiple) {
            $choices = chznObj.search_container.parent();
            $toTruncate = $choices.find('li.search-choice > span:not(.uwr-temp-truncated)');
            if ($toTruncate.length > 0) {
                $parent = $toTruncate.parent();
                wdiff = $parent.outerWidth() - $parent.width() + parseInt($parent.css('marginLeft'), 10) * 2;
                width = $choices.width() - wdiff;

                $toTruncate.truncate({
                    visibleTrailChars: visibleTrailChars,
                    width: width
                });
                $toTruncate.addClass('uwr-temp-truncated');
            }
        } else {
            $item = chznObj.selected_item.find('span').first();
            $item.truncate({
                visibleTrailChars: visibleTrailChars,
                width: $item.width() - 1
            });
        }
    }
}

function normalizeOptionValue(value) {
    return value.replace(/ /g, '_');
}

function contains(str, sub) {
    return str && str.indexOf(sub) > -1;
}

function removeClassesLike($item, classAttr, like) {
    if (classAttr) {
        var classArray = classAttr.split(' '),
            classItem,
            i,
            len;
        for (i = 0, len = classArray.length; i < len; i++) {
            classItem = classArray[i];
            if (contains(classItem, like)) {
                $item.removeClass(classItem);
            }
        }
    }
}

function setIconClasses($item, optionValue) {
    var classAttr = $item.attr('class');
    removeClassesLike($item, classAttr, 'uwr-advanced-dropdown-item-');
    $item.addClass('uwr-advanced-dropdown-text-selected');
    $item.addClass('uwr-advanced-dropdown-item');
    if (optionValue) {
        $item.addClass('uwr-advanced-dropdown-item-' + normalizeOptionValue(optionValue));
    }
}

function setOriginalListClasses($item, classes) {
    $item.addClass(classes);
}

function getNewChoice(oldChoices, newChoices) {
    var newChoice;
    if (oldChoices) {
        if (newChoices.length > 1) {
            newChoice = $(newChoices).not(oldChoices)[0];
        } else {
            newChoice = newChoices[0];
        }
    } else {
        newChoice = newChoices[0];
    }
    return newChoice;
}

function getSelectedChoices(chznObj) {
    var selectedChoices;
    if (chznObj.is_multiple) {
        var newValueObjs = $.grep(chznObj.results_data, function (e) {
            return e.selected === true;
        });
        selectedChoices = $.map(newValueObjs, function (e) {
            return e.value;
        });
    } else {
        selectedChoices = chznObj.current_value;
    }
    return selectedChoices;
}

function setUserIconClassesForSelected(chznObj, selectedValue, $item) {
    var previousClass,
        resultItem;
    if (selectedValue && $item) {
        resultItem = $.grep(chznObj.results_data, function (e) {
            return e.value === selectedValue;
        });
        if (resultItem && (resultItem.length > 0)) {
            if (!chznObj.is_multiple) {
                previousClass = $item.data('userclass');
                if (previousClass) {
                    $item.removeClass(previousClass);
                }
                $item.data('userclass', resultItem[0].classes);
            }
            $item.addClass(resultItem[0].classes);
        }
    }
}

function setIconForSelected(chznObj, oldChoices) {
    var $choices,
        $toHandle,
        selectedValue;
    if (chznObj.is_multiple) {
        $choices = chznObj.search_container.parent();
        $toHandle = $choices.find('li.search-choice > span:not(.uwr-advanced-dropdown-item)');
        if ($toHandle) {
            selectedValue = getNewChoice(oldChoices, getSelectedChoices(chznObj));
            setIconClasses($toHandle, selectedValue);
        }
    } else if (chznObj.current_selectedIndex >= 0) {
        selectedValue = chznObj.results_data[chznObj.current_selectedIndex].value;
        $toHandle = chznObj.selected_item.find('span');
        setIconClasses($toHandle, selectedValue);
    }
    setUserIconClassesForSelected(chznObj, selectedValue, $toHandle);
}

/**
 * Modified chosen method. Needed to be modified because of disabled options.
 *
 * To support additional functions this method can accept a user select event (if a user chooses from the
 * dropdown with mouse) and a script event (if the selection is changed by a code via setValue).
 *
 * In the first case no item is defined, because it will be originated from the user selection. In the second
 * case there is no result highlighting, because it will be set by the script and there were no selection in
 * the option list
 *
 * So we have to check item and result_highlighting (chosen inner object) too.
 */
/* eslint-disable */
function modifiedResultSelect(chznObj, evt) {
    var high, item, selected_index,
    // added code ---
        triggerChange = true;
    if (evt.item) {
        item = evt.item;
    }
    if (evt.hasOwnProperty('triggerChange')) {
        triggerChange = evt.triggerChange;
    }
    // ---
    if (chznObj.result_highlight || item) {
        high = chznObj.result_highlight;
        if (high) {
            chznObj.result_clear_highlight();
            if (chznObj.is_multiple && chznObj.max_selected_options <= chznObj.choices_count()) {
                chznObj.form_field_jq.trigger("chosen:maxselected", {
                    chosen: chznObj
                });
                return false;
            }
            if (chznObj.is_multiple) {
                high.removeClass("active-result");
            } else {
                if (chznObj.result_single_selected) {
                    chznObj.result_single_selected.removeClass("result-selected");
                    selected_index = chznObj.result_single_selected[0].getAttribute('data-option-array-index');
                    chznObj.results_data[selected_index].selected = false;
                }
                chznObj.result_single_selected = high;
            }
            high.addClass("result-selected");
            if (!item) {
                item = chznObj.results_data[high[0].getAttribute("data-option-array-index")];
            }
        }
        // added code ---
        if (!item || chznObj.form_field.options[item.options_index].disabled) {
            return false;
        }
        // ---
        item.selected = true;
        chznObj.form_field.options[item.options_index].selected = true;
        chznObj.selected_option_count = null;
        if (chznObj.is_multiple) {
            chznObj.choice_build(item);
        } else {
            chznObj.single_set_selected_text(item.text);
        }
        if (!((evt.metaKey || evt.ctrlKey) && chznObj.is_multiple)) {
            chznObj.results_hide();
        }
        chznObj.search_field.val("");
        if (chznObj.is_multiple || chznObj.form_field.selectedIndex !== chznObj.current_selectedIndex) {
            // added code
            if (triggerChange) {
            // ---
                chznObj.form_field_jq.trigger("change", {
                    'selected': chznObj.form_field.options[item.options_index].value
                });
            // added code
            }
            // ---
        }
        chznObj.current_selectedIndex = chznObj.form_field.selectedIndex;
        return chznObj.search_field_scale();
    }
}
/* eslint-enable */

/**
 * The selection handling object, which extends the original operation of
 * chosen (modifiedResultSelect) with own features. New features in connection
 * with selection can be placed at this point.
 */
function chosenSelectHandler(chznObj, attrs, evt) {
    var oldChoices = getSelectedChoices(chznObj);

    // call the modified original
    if (evt) {
        modifiedResultSelect(chznObj, evt);
    }

    // icon
    setIconForSelected(chznObj, oldChoices);

    // ellipsis
    changeSelectedText(chznObj, attrs.visibleTrailChars);
}

function modifySingleSelectedProgrammatically(chznObj, value) {
    var i,
        selectedItem;
    for (i = 0; i < chznObj.results_data.length; i++) {
        if (value === chznObj.results_data[i].value) {
            selectedItem = chznObj.results_data[i];
            chznObj.current_selectedIndex = i;
            break;
        }
    }
    chosenSelectHandler(chznObj, {}, {item: selectedItem, triggerChange: false});
}

/**
 * This is the bridge between chosen selection handling and the API function setValue. In
 * this method the item originated from the setValue is selected and propagated in an
 * internal event object to the selection handling code (chosenSelectHandler).
 */
function modifySelectedProgrammatically($obj, value) {
    var j,
        chznObj = getChozenObj($obj);
    if (chznObj) {
        if (chznObj.is_multiple) {
            $obj.val([]);
            $obj.trigger('chosen:updated.chosen');
        }
        if (value instanceof Array) {
            if (chznObj.is_multiple) {
                for (j = 0; j < value.length; j++) {
                    modifySingleSelectedProgrammatically(chznObj, value[j]);
                }
            } else {
                modifySingleSelectedProgrammatically(chznObj, value[0]);
            }
        } else {
            modifySingleSelectedProgrammatically(chznObj, value);
        }
    }
}

function setSelectHandler(chznObj, attrs) {
    chznObj.result_select = function (evt) {
        chosenSelectHandler(chznObj, attrs, evt);
    };
    changeSelectedText(chznObj, attrs.visibleTrailChars);
    var oldChoices = getSelectedChoices(chznObj);
    setIconForSelected(chznObj, oldChoices);
}

function setBorderClass(chznObj, attrs) {
    if (attrs.noBorder) {
        if (chznObj.is_multiple) {
            chznObj.search_choices.addClass('uwr-advanced-dropdown-no-border');
        } else {
            chznObj.selected_item.addClass('uwr-advanced-dropdown-no-border');
        }
    }
}

function setTextClasses(chznObj) {
    if (chznObj.is_multiple) {
        chznObj.search_choices.addClass('uwr-advanced-dropdown-text-selected');
    } else {
        chznObj.selected_item.addClass('uwr-advanced-dropdown-text-selected');
    }
    chznObj.search_results.find('li').addClass('uwr-advanced-dropdown-text-list');
}

function prepareListClasses(chznObj) {
    $(chznObj.dropdown).find('li').each(function () {
        var value = null,
            id = $(this).data('option-array-index'),
            results = chznObj.results_data,
            i,
            len,
            classes,
            data;
        for (i = 0, len = results.length; i < len; i++) {
            data = results[i];
            if (data.array_index === id) {
                value = data.value;
                classes = data.classes;
                break;
            }
        }
        $(this).addClass('uwr-advanced-dropdown-text-list');
        setIconClasses($(this), value);
        setOriginalListClasses($(this), classes);
    });
}

function getSelectOptions($selectNode) {
    return $('option', $selectNode);
}

function escapeOptions($selectNode) {
    getSelectOptions($selectNode).each(function () {
        this.text = htmlEscape(this.text);
        if (this.disabled === true && this.selected === true) {
            this.selected = false;
        }
    });
}

function isEmptySelect($selectNode) {
    var $options = getSelectOptions($selectNode),
        empty = true,
        i;
    for (i = 0; i < $options.length; i++) {
        if ($options[i].text) {
            empty = false;
            break;
        }
    }
    return empty;
}

function prepareForConversion($selectNode, attrs) {
    if (isEmptySelect($selectNode) && attrs.emptyPlaceholder) {
        $selectNode.data('originalPlaceholder', attrs.placeholder || '');
        $selectNode.attr('data-placeholder', attrs.emptyPlaceholder);
    } else {
        if ($selectNode.data('originalPlaceholder')) {
            $selectNode.attr('data-placeholder', $selectNode.data('originalPlaceholder'));
            $selectNode.removeData('originalPlaceholder');
        } else if ($selectNode.data('originalPlaceholder') === '') {
            $selectNode.removeAttr('data-placeholder');
            $selectNode.removeData('originalPlaceholder');
        } else if (attrs.placeholder) {
            $selectNode.attr('data-placeholder', attrs.placeholder);
        } else {
            $selectNode.removeAttr('data-placeholder');
        }
    }
    $selectNode.removeAttr('placeholder');

    escapeOptions($selectNode);
    // TRAC#1364: overwrite Chosen's disabling function
    if (attrs.disabled) {
        $selectNode.removeAttr('disabled').attr('data-disabled', attrs.disabled);
    }
}

function copyOriginalClasses(chznObj, originalClasses) {
    chznObj.container
        .addClass(originalClasses)
        .removeClass('chosen-select');
    removeClassesLike(chznObj.container, originalClasses, 'cuiListBox');
}

function resetDefaultSelectedValues(chznObj, $originalSelect) {
    var $options = getSelectOptions($originalSelect);
    $options.each(function () {
        this.selected = this.defaultSelected;
    });
}

function setResetHandler(chznObj, $originalSelect) {
    $('form').bind('reset', function () {
        reset($originalSelect);
    });
}

/**
 * Extracted and changed functionality from Chosen search.
 * Originally only ' ' (space) and '[' was checked.
 */
function isStringToBeSplit(valueHtml) {
    return valueHtml.indexOf(' ') >= 0
        || valueHtml.indexOf('&nbsp;') >= 0
        || valueHtml.indexOf('[') >= 0
        || valueHtml.indexOf(']') >= 0
        || valueHtml.indexOf('(') >= 0
        || valueHtml.indexOf(')') >= 0
        || valueHtml.indexOf('"') >= 0;
}

/**
 * Replaces &nbsp; to space for the result list (otherwise &nbsp; will be shown in the result list).
 */
function prepareText(text) {
    return htmlEscape(text.replace(/&nbsp;/g, ' '));
}

/**
* Extracted and changed functionality from Chosen search.
* Originally it replaced only [ and ] to '' (nothing).
* For correct search some special characters must be handled as space.
*/
function prepareValueForSearch(valueHtml) {
    return valueHtml.replace(/\&nbsp;|\[|\]|\(|\)|\"/g, ' ');
}

/**
 * UBSWI-945: support for multi-line entries in single select ADD
 */
function replaceChosenSingleSetSelectedText(chznObj, attrs) {
    /* eslint-disable */
    chznObj.single_set_selected_text = function(text) {
        if (text == null) {
            text = this.default_text;
            }
            if (text === this.default_text) {
            this.selected_item.addClass("chosen-default");
            } else {
            this.single_deselect_control_build();
            this.selected_item.removeClass("chosen-default");
            }
            if (attrs.labelType === 'html') { // UBSWI-945: fixed selected items when option label type is HTML
                return this.selected_item.find("span").html(text);
            }
            return this.selected_item.find("span").text(text);
    };
    /* eslint-enable */
}

/**
 * UBSWI-945: support for multi-line entries in multiple select ADD
 */
function replaceChosenChoiceBuild(chznObj, attrs) {
    /* eslint-disable */
    chznObj.choice_build = function(item) {
        var choice, close_link,
        _this = this;

        choice = $('<li />', {
        "class": "search-choice"
        }).html("<span>" + getOptionLabel(item, attrs.labelType) + "</span>"); // UBSWI-945: fixed selected items when option label type is HTML
        if (item.disabled) {
        choice.addClass('search-choice-disabled');
        } else {
        close_link = $('<a />', {
            "class": 'search-choice-close',
            'data-option-array-index': item.array_index
        });
        close_link.bind('click.chosen', function(evt) {
            return _this.choice_destroy_link_click(evt);
        });
        choice.append(close_link);
        }
        return this.search_container.before(choice);
    };
    /* eslint-enable */
}

/**
 * This function adds extra space after every tag's closing bracket (">")
 * when labelType is 'html' to prepare label text to search
 */
function prepareOptionLabel(option, labelType) {
    var label = option.html;
    if (labelType === 'html') {
        label = option.text.replace(/>/g, function (tag) {
            return tag + ' ';
        });
    }
    return label;
}

/**
 * The original chosen search function can't handle the &nbsp; and " characters, therefore we need to replace it.
 * We cloned the original function and changed only the minimal necessary parts where we extracted the changed
 * functionality to separate functions.
 */
function replaceChosenSearch(chznObj, attrs) { // UBSWI-945: enabled HTML label in option
    /* eslint-disable */
    var _i,
        _j,
        _len,
        _len1,
        parts,
        part;

    chznObj.winnow_results = function() {
        var escapedSearchText, escapedSearchTextElem, option, regex, regexAnchor, results, results_group, searchText, searchTextSplitted, searchTextElem, startpos, text, zregex, _i, _len, _ref, preparedOptionHtml; //  UBSWI-280: added extra variables to escapedSearchText splitting

        this.no_results_clear();
        results = 0;
        searchText = this.get_search_text();
        escapedSearchText = searchText.replace(/[-[\]{}()*+?.,\\^$|#]/g, "\\$&"); // UBSWI-280: escape special regular expression characters: . \ + * ? [ ^ ] $ ( ) { } = ! < > | : -
        escapedSearchText = escapedSearchText.replace(/\s+/g, ".*\\s"); // UBSWI-280: extend search text to find word starting matches
        regexAnchor = this.search_contains ? "" : "\\s"; // UBSWI-280: add starting space before 1st search word
        regex = new RegExp(regexAnchor + escapedSearchText, 'i');
        _ref = this.results_data;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
            option = _ref[_i];
            option.search_match = false;
            results_group = null;
            if (this.include_option_in_results(option)) {
            if (option.group) {
                option.group_match = false;
                option.active_options = 0;
            }
            if ((option.group_array_index != null) && this.results_data[option.group_array_index]) {
                results_group = this.results_data[option.group_array_index];
                if (results_group.active_options === 0 && results_group.search_match) {
                results += 1;
                }
                results_group.active_options += 1;
            }
            if (!(option.group && !this.group_search)) {
                option.search_text = htmlEscape(option.group ? option.label : prepareOptionLabel(option, attrs.labelType)); // UBSWI-945: enabled HTML label in option
                option.search_match = this.search_string_match(" " + option.search_text, regex); // UBSWI-280: add starting space before 1st world so that it can be found
                if (option.search_match && !option.group) {
                results += 1;
                } else if (this.enable_split_word_search && option.html && isStringToBeSplit(option.html)) { // UBSWI-143: fix search without quotes (block begin)
                    parts = prepareValueForSearch(option.html).split(" ");
                    if (parts.length) {
                        for (_j = 0, _len1 = parts.length; _j < _len1; _j++) {
                            part = parts[_j];
                            if (regex.test(part)) {
                                option.search_match = true;
                                results += 1;
                            }
                        }
                    }
                } // UBSWI-143: fix search without quotes (block end)
                if (option.search_match) {
                // UBSWI-281: new highlighting feature (block begin)
                startpos = 0;
                searchTextSplitted = searchText.split(" ");
                for (_j = 0, _len1 = searchTextSplitted.length; _j < _len1; _j++) {
                    searchTextElem = searchTextSplitted[_j];
                    if (searchTextElem.length) {
                    preparedOptionHtml = " " + prepareText(option.search_text);
                    escapedSearchTextElem = searchTextElem.replace(/\s+/g, ".*\\s"); // UBSWI-280: extend search text to find word starting matches
                    escapedSearchTextElem = escapedSearchTextElem.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"); // UBSWI-280: escape special regular expression characters: . \ + * ? [ ^ ] $ ( ) { } = ! < > | : -
                    zregex = new RegExp(regexAnchor + escapedSearchTextElem, 'i');
                    startpos += preparedOptionHtml.substr(startpos).search(zregex);
                    startpos += this.search_contains ? 0 : 1; // UBSWI-281: add length of extra starting space; UBSWI-2037: extra starting space length only added for non-partial searching
                    text = preparedOptionHtml.substr(0, startpos + searchTextElem.length) + '</em>' + preparedOptionHtml.substr(startpos + searchTextElem.length);
                    option.search_text = text.substr(0, startpos) + '<em>' + text.substr(startpos);
                    startpos += 9; // UBSWI-281: add length of highlighting ('<em>' and '</em>')
                    }
                } // UBSWI-281: new highlighting feature (block end)
                if (results_group != null) {
                    results_group.group_match = true;
                }
                } else if ((option.group_array_index != null) && this.results_data[option.group_array_index].search_match) {
                option.search_match = true;
                }
            }
            }
        }
        this.result_clear_highlight();
        if (results < 1 && searchText.length) {
            this.update_results_content("");
            return this.no_results(searchText);
        } else {
            this.update_results_content(this.results_option_build());
            prepareListClasses(this);
            return this.winnow_results_set_highlight();
        }
    };
    /* eslint-enable */
}

// TRAC#1364: overwrite Chosen's disabling function
function replaceChosenResultsShow(chznObj) {
    /* eslint-disable */
    /*
        * @overwrite of chosen activate_field function for tablet devices
        */

    chznObj.activate_field = function(){
        this.container.addClass("chosen-container-active");
        this.active_field = true;
        this.search_field.val(this.search_field.val());
        return (common.isTouchDevice() ? this.search_field.blur() : this.search_field.focus());
    };

    chznObj.results_show = function() { // added code
        if (!this.container.hasClass('chosen-disabled')) {
            if (this.is_multiple
                    && this.max_selected_options <= this
                            .choices_count()) {
                this.form_field_jq.trigger("chosen:maxselected", {
                    chosen : this
                });
                return false;
            }
            this.container.addClass("chosen-with-drop");
            this.form_field_jq.trigger("chosen:showing_dropdown", {
                chosen : this
            });
            this.dropdown.css( { // added code
                'left' : 0,
                'top' : '100%'
            });
            this.results_showing = true;
            this.search_field.focus();
            this.search_field.val(this.search_field.val());
            return this.winnow_results();
        } // added code
    };
    /* eslint-enable */
}

function replaceChosenResultsHide(chznObj) {
    /* eslint-disable */
    chznObj.results_hide = function() {
        if (this.results_showing) {
            this.result_clear_highlight();
            this.container.removeClass("chosen-with-drop");
            this.form_field_jq.trigger("chosen:hiding_dropdown", {
                chosen : this
            });
            this.dropdown.css( { // added code
                'left' : -9999
            });
        }
        return this.results_showing = false;
    };
    /* eslint-enable */
}

function setActivateFieldHandler(chznObj) {
    chznObj.activate_field = (function (activateField) {
        return function () {
            var activateFieldResult;
            if (chznObj.is_disabled) {
                activateFieldResult = false;
            } else {
                activateFieldResult = activateField.call(this);
            }
            return activateFieldResult;
        };
    })(chznObj.activate_field);
}

function addFeaturesToChozen(chznObj, attrs, $originalSelect) {
    replaceChosenSingleSetSelectedText(chznObj, attrs);
    replaceChosenChoiceBuild(chznObj, attrs);
    replaceChosenSearch(chznObj, attrs);
    replaceChosenResultsShow(chznObj);
    replaceChosenResultsHide(chznObj);
    setListWidth(chznObj, attrs);
    setListHeight(chznObj, attrs);
    setBorderClass(chznObj, attrs);
    setTextClasses(chznObj);
    prepareListClasses(chznObj);
    setResetHandler(chznObj, $originalSelect);
    setActivateFieldHandler(chznObj);
    setSelectHandler(chznObj, attrs);
}

function enableElement(chznObj) {
    if (chznObj) {
        chznObj.form_field_jq[0].disabled = false;
        chznObj.search_field[0].style.cursor = '';
        chznObj.search_field_disabled();
    }
}

function disableElement(chznObj) {
    if (chznObj) {
        chznObj.form_field_jq[0].disabled = true;
        chznObj.search_field[0].style.cursor = 'default';
        chznObj.search_field_disabled();
    }
}

function resetElement(selector) {
    var $selector = $(selector),
        chznObj = getChozenObj($selector);
    if (chznObj) {
        resetDefaultSelectedValues(chznObj, $selector);
        internalInit($selector, true, function () {});
    }
}

function transformToChozen($selectNode, attrs) {
    var select = $selectNode.chosen({
        no_results_text: attrs.noResultsText,
        disable_search: attrs.noSearch || false,
        search_contains: attrs.partialSearch || false,
        width: $selectNode.css('width')
    });
    return $(select);
}

function getChozenObj($select) {
    return $select.data('chosen');
}

function getSelection(chznObj, $originalSelect) {
    var $options = getSelectOptions($originalSelect),
        $selectedOption = null,
        selectedIndex = 0;
    $options.each(function (i) {
        if (0 <= chznObj.current_selectedIndex
                && i < chznObj.results_data.length
                && this.value === chznObj.results_data[chznObj.current_selectedIndex].value) {
            selectedIndex = i;
            $selectedOption = this;
        }
    });
    return {
        index: selectedIndex,
        option: $selectedOption
    };
}

function updateResultsData(chznObj, $originalSelect) {
    var selection = {};

    // This have to be before the single selected is set because it nulls that
    chznObj.results_update_field();
    if (!chznObj.is_multiple) {
        selection = getSelection(chznObj, $originalSelect);
        if (selection.option) {
            chznObj.result_single_selected = $(selection.option);
            chznObj.current_selectedIndex = selection.index;
            chznObj.result_single_selected[0].setAttribute('data-option-array-index', selection.index);
        }
    }
}

function transformSelectToAdvancedDropdown($selectNode) {
    var attrs = {
            placeholder: $selectNode.attr('placeholder') || $selectNode.attr('data-placeholder'),
            emptyPlaceholder: $selectNode.attr('data-empty-placeholder'),
            noResultsText: $selectNode.attr('data-no-results-text'),
            listAutoWidth: $selectNode.attr('data-list-autowidth'),
            listMaxWidth: $selectNode.attr('data-list-maxwidth'),
            listMinWidth: $selectNode.attr('data-list-minwidth'),
            listMaxHeight: $selectNode.attr('data-list-maxheight'),
            visibleTrailChars: $selectNode.attr('data-visible-trail-chars'),
            listAlignment: $selectNode.attr('data-list-alignment'),
            noSearch: $selectNode.attr('data-no-search'),
            partialSearch: $selectNode.attr('data-partial-search'),
            noBorder: $selectNode.attr('data-no-border'),
            width: $selectNode.attr('width'),
            style: $selectNode.attr('style'),
            disabled: $selectNode.attr('disabled') || $selectNode.attr('data-disabled'),
            labelType: $selectNode.attr('data-label-type')
        },
        originalClasses = $selectNode.attr('class'),
        $originalSelect,
        chznObj;

    prepareForConversion($selectNode, attrs);

    $originalSelect = transformToChozen($selectNode, attrs);
    if ($originalSelect) {
        chznObj = getChozenObj($originalSelect);
        if (chznObj) {
            updateResultsData(chznObj, $originalSelect);
            copyOriginalClasses(chznObj, originalClasses);
            addFeaturesToChozen(chznObj, attrs, $originalSelect);

            chosenSelectHandler(chznObj, attrs);

            // TRAC#1364: overwrite Chosen's disabling function
            if (attrs.disabled) {
                disable(chznObj);
            }

            // UBSWI-297: fix disabled style in IE8
            if (window.navigator.appName === 'Microsoft Internet Explorer' && document.documentMode < 9) {
                chznObj.container.addClass('uwr-advanced-dropdown-ie8');
            } else {
                chznObj.container.removeClass('uwr-advanced-dropdown-ie8');
            }
        }
    }
}

function transformAllSelectsToAdvancedDropdown(selector, reinitAll) {
    var $selectNodes = $(selector);
    $selectNodes.addClass('chosen-select');
    $selectNodes.each(function () {
        var $selectNode = $(this),
            chznObj = getChozenObj($selectNode);
        if (chznObj) {
            if (reinitAll) {
                $selectNode.removeClass('chosen-done');
                $('#' + chznObj.container_id).remove();
            }
        }
        transformSelectToAdvancedDropdown($selectNode);
    });
}

/** function browser_is_supported as defined by Chosen 1.0.0 internally
 *
 * as it might not be possible to access it from outside without having
 * a transformed select (and thus no chznObj) it has to be duplicated
 * (funct. name "camelized", doublequotes replaced with singlequotes,
 * indendation adapted for ES linting)
 */
function chosenBrowserIsSupported() {
    if (window.navigator.appName === 'Microsoft Internet Explorer') {
        return document.documentMode >= 8;
    }
    if (/iP(od|hone)/i.test(window.navigator.userAgent)) {
        return false;
    }
    if (/Android/i.test(window.navigator.userAgent)) {
        if (/Mobile/i.test(window.navigator.userAgent)) {
            return false;
        }
    }
    return true;
}

/**
 * isUnsupportedBrowser returns true in browsers that should render the
 * select as native dropdown (IE before IE8, Android and iPhone)
 */
function isUnsupportedBrowser() {
    return !chosenBrowserIsSupported();
}

function createState() {
    if (!state) {
        state = {
            onReadyHandler: null,
            // This flag shows if all ADD's have been fully ready when the page loaded.
            isReady: false
        };
    }
}

function setReadyHandler(handler) {
    if (typeof handler === 'function') {
        createState();
        if (state.isReady) {
            handler();
        } else {
            state.onReadyHandler = handler;
        }
    }
}

function internalInit(selector, reinitAll) {
    createState();
    if (isUnsupportedBrowser()) {
        $(selector).removeClass('uwr-advanced-dropdown');
    } else {
        transformAllSelectsToAdvancedDropdown(selector, reinitAll);
    }
}

function callReadyHandler() {
    state.isReady = true;
    common.invoke(state.onReadyHandler);
    state.onReadyHandler = null;
}

/**
 * Check a value is valid: not undefined, empty string or array, or some combination of them.
 */
export function isValidValue(value) {
    var valid = false,
        i;
    if (value !== undefined) {
        if ($.isArray(value)) {
            for (i = 0; !valid && i < value.length; i++) {
                if (isValidValue(value[i])) {
                    valid = true;
                }
            }
        } else
        if (common.isString(value) && 0 < $.trim(value).length) {
            valid = true;
        }
    }
    return valid;
}

/**
 * Supported use cases:
 * - init();
 * - init(callback);
 * - init(selector);
 * - init(selector, callback);
 */
export function init(selector, callback) {
    if (arguments.length === 0) {
        internalInit('select.uwr-advanced-dropdown', false);

    } else if (arguments.length === 1) {
        var firstArg = selector;
        if (typeof firstArg === 'function') {
            internalInit('select.uwr-advanced-dropdown', true);
            common.invoke(firstArg);
        } else {
            internalInit(firstArg, true);
        }

    } else if (arguments.length === 2) {
        internalInit(selector, true);
        common.invoke(callback);
    }

    callReadyHandler();
}

export function setValue(selector, value, callback) {
    if (isValidValue(value)) {
        $(selector).each(function () {
            var $obj = $(this),
                oldValue = $obj.val();
            modifySelectedProgrammatically($obj, value);
            if (oldValue !== value) {
                $obj.trigger('change');
            }
        });
        common.invoke(callback);
    }
}

export function ready(handler) {
    setReadyHandler(handler);
}

export function enable(selector, callback) {
    $(selector).each(function () {
        enableElement(getChozenObj($(this)));
    });
    common.invoke(callback);
}

export function disable(selector, callback) {
    $(selector).each(function () {
        disableElement(getChozenObj($(this)));
    });
    common.invoke(callback);
}

export function reset(selector, callback) {
    $(selector).each(function () {
        resetElement(this);
    });
    common.invoke(callback);
}



//////////////////
// WEBPACK FOOTER
// ./widgets/AdvancedDropdown/js/advancedDropdown.js
// module id = 22
// module chunks = main